var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgOrangeTick = function SvgOrangeTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 35c-8.285 0-15-6.715-15-15S11.715 5 20 5s15 6.715 15 15-6.715 15-15 15z",
    fill: "url(#orangeTick_svg__paint0_linear_11572_2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.667 16.667L18.333 25l-5-5",
    stroke: "#fff",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "orangeTick_svg__paint0_linear_11572_2",
    x1: 20,
    y1: 5,
    x2: 20,
    y2: 35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED966A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD1558"
  })))));
};
export default SvgOrangeTick;